import { isArray, mergeWith, merge } from "lodash";
import {
  CREATE_CLIENTNOTE_REQUEST,
  CREATE_CLIENTNOTE_SUCCESS,
  CREATE_CLIENTNOTE_FAILURE
} from "../types";

function customizer(objValue, srcValue) {
  if (isArray(objValue)) {
    return objValue.concat(srcValue);
  }
}

export default (state, action) => {
  switch (action.type) {
    case CREATE_CLIENTNOTE_REQUEST:
      return {
        ...state,
        loadingClientNotes: true
      };
    case CREATE_CLIENTNOTE_SUCCESS:
      return {
        ...state,
        loadingClientNotes: false,
        clientNotes: mergeWith(
          merge({}, action.payload),
          state.clientNotes,
          customizer
        )
      };
    case CREATE_CLIENTNOTE_FAILURE:
      return {
        ...state,
        loadingClientNotes: false
      };
    default:
      return state;
  }
};
